export const CONTACTS_LISTS_ACCESS = 'contacts-lists-access';
export const CONTACTS_LISTS_READ = 'contacts-lists-read';
export const CONTENT_EDITOR_ACCESS = 'content-editor-access';
export const MARKETING_VIDEO = 'marketing-video';
export const SERVICE_CONTENT_RESTRICTED_WRITE = 'service-content-restricted-write';
export const KNOWLEDGE_BASE_PRIVATE_CONTENT_PUBLISH = 'knowledge-base-private-content-publish';
export const SERVICE_KNOWLEDGE_ACCESS_SCOPE = 'service-knowledge-access';
export const SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE = 'service-knowledge-article-write';
export const SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE = 'service-knowledge-article-publish';
export const SERVICE_KNOWLEDGE_CUSTOM_DOMAIN_WRITE = 'service-knowledge-custom-domain-write';
export const CONTENT_CORE_API_ACCESS = 'content-core-api-access';
export const CUSTOMER_PORTAL_CONFIG_READ = 'customer-portal-config-read';
export const KNOWLEDGE_CATEGORY_EDIT = 'knowledge-category-edit';
export const KNOWLEDGE_BASE_WRITE = 'knowledge-base-write';